<template>
  <div class="container text-left font-weight-bold">
    <el-card class="mt-3 p-3">
      <span>{{ $t('general.forgot_password_message') }}</span>
      <el-input v-model="email" type="email" />
      <el-button class="mt-2 float-right" type="primary" @click="onSubmit">
        {{ $t('general.submit') }}
      </el-button>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'PasswordForgotView',
  components: {},
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {
      email: '',
    };
  },
  computed: {},
  methods: {
    async onSubmit() {
      if (!this.email) {
        this.$message.info(this.$t('messages.fill_out_item', { field: 'E-Mail' }));
        return;
      }
      try {
        let result = await this.$parse.Cloud.run('forgotPassword', { email: this.email, origin: this.$clientUrl }, {});
        this.$message.info(this.$t(result.message));
      } catch (e) {
        this.$message.info(this.$t(e.message));
      }

      this.email = '';
    },
  },
};
</script>

<style scoped></style>
